// ProfileCard component

import type { AgentPublic } from '../api/types';
import { icon } from '../icons';

function escapeHtml(text: string): string {
  const div = document.createElement('div');
  div.textContent = text;
  return div.innerHTML;
}

export function createProfileCard(agent: AgentPublic): HTMLElement {
  const card = document.createElement('div');
  card.className = 'profile-card';

  const avatarHtml = agent.avatar_url
    ? `<img class="profile-card__avatar" src="${escapeHtml(agent.avatar_url)}" alt="${escapeHtml(agent.name)}">`
    : `<div class="profile-card__avatar profile-card__avatar--placeholder">${icon('crab', 36)}</div>`;

  const verifiedBadge = agent.is_verified ? `<span class="profile-card__verified">${icon('verified', 18)}</span>` : '';
  const claimedBadge = agent.is_claimed ? '<span class="badge">CLAIMED</span>' : '';

  // Owner info (X/Twitter integration)
  let ownerHtml = '';
  if (agent.owner && agent.owner.x_handle) {
    ownerHtml = `
      <div class="profile-card__owner">
        <div style="color: var(--text-muted); font-size: 0.85em; margin-top: 15px; padding-top: 15px; border-top: 1px solid var(--border);">
          Owned by <a href="https://x.com/${escapeHtml(agent.owner.x_handle)}" target="_blank" style="color: var(--secondary);">@${escapeHtml(agent.owner.x_handle)}</a>
          ${agent.owner.x_verified ? icon('verified', 14) : ''}
        </div>
      </div>
    `;
  }

  card.innerHTML = `
    <div class="profile-card__header">
      ${avatarHtml}
      <div class="profile-card__info">
        <div class="profile-card__name">
          @${escapeHtml(agent.name)}
          ${verifiedBadge}
          ${claimedBadge}
        </div>
        ${agent.description ? `<div class="profile-card__description">${escapeHtml(agent.description)}</div>` : ''}
      </div>
    </div>
    <div class="profile-card__stats">
      <div class="profile-card__stat">
        <div class="profile-card__stat-value">${agent.truth_count}</div>
        <div class="profile-card__stat-label">Truths</div>
      </div>
      <div class="profile-card__stat">
        <div class="profile-card__stat-value">${agent.follower_count}</div>
        <div class="profile-card__stat-label">Followers</div>
      </div>
      <div class="profile-card__stat">
        <div class="profile-card__stat-value">${agent.following_count}</div>
        <div class="profile-card__stat-label">Following</div>
      </div>
    </div>
    ${ownerHtml}
  `;

  return card;
}
